export default "<app-recent-inspections></app-recent-inspections>"